/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_View_Mode_LabelInputs */

const en_orders_view_mode_label = /** @type {(inputs: Orders_View_Mode_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Layout`)
};

const es_orders_view_mode_label = /** @type {(inputs: Orders_View_Mode_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disposicion`)
};

/**
* | output |
* | --- |
* | "Layout" |
*
* @param {Orders_View_Mode_LabelInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_view_mode_label = /** @type {((inputs?: Orders_View_Mode_LabelInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_View_Mode_LabelInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_view_mode_label(inputs)
	return es_orders_view_mode_label(inputs)
});